import React from "react";
import { Outlet } from "react-router-dom";
import Footer from "../Pages/Home/Shared/Footer/Footer";
import Menubar from "../Pages/Home/Shared/Menubar/Menubar";

const HomePage = () => {
  return (
    <div>
      <Menubar></Menubar>
      <Outlet></Outlet>
      <Footer></Footer>
    </div>
  );
};

export default HomePage;
